import React from 'react';
import {
  Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
//import Contact from '../HomePageNew/Contact';


class PrivacyPolicy extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentWillMount() {
   
  }
  
  render() {
    return (
      <div>
        <MenuNew />
        <NavbarDrop />

        <Container id="privacy_policy">
          <div className="privacy_policy_img">
            <Row style={{marginRight: 0}}>
              <Col style={{marginTop:60}} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
              <Col id="privacy_policy_text" xs="12" sm="12" md="8" lg="8" xl="8">
                <h1 className="privacy_policy_h1">
                POLÍTICAS DE PRIVACIDADE
                </h1>
                <p className="privacy_policy_p">
                  NÓS TEMOS COMPROMISSO COM A SUA SEGURANÇA. COM A<br/>
                  GENTE, SUAS INFORMAÇÕES ESTÃO SEMPRE PROTEGIDAS.
                </p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
            </Row>
          </div>

          <hr className="hr_policy" />
          
          <div>
            {/******** titulo 1 ********/}
            <div className="div_text_policy">
              <p className="text_policy">A Dental Center é comprometida com a privacidade e uso transparente dos dados de seus clientes, durante todo o tempo de utilização dos nossos serviços.</p>
              <p className="text_policy">Esse documento foi preparado para explicar, de forma simples, como se dá o processo de tratamento de dados: coleta, armazenamento e exclusão.</p>
              <p className="text_policy">Suas informações pessoais são de suma importância, por isso, preparamos o seguinte resumo:</p>
              
              <p className="title_policy">1. Agente de tratamento dos seus dados: Dental center</p>

              <p className="text_policy">Papel da Dental Center no tratamento dos dados: Exclusivo controlador</p>
              <p className="text_policy">Tipo de informações pessoais coletadas: As necessárias para cadastro e identificação em nosso sistema,
              as quais são recolhidas através dos seguintes meios: site, aplicativo e inteligência artificial.</p>
              <p className="text_policy">Com que finalidade utilizamos seus dados pessoais:</p>
              <p className="text_policy">- Para cadastro em nosso sistema</p>
              <p className="text_policy">- Para identificação em nosso sistema, caso necessite de algum desses serviços: geração de carteirinha,
              acesso a boleto (caso seja esse o meio de pagamento do cliente), troca de cartão de crédito,
              inclusão/exclusão de beneficiários, cancelamento e qualquer outra forma de alteração de dados cadastrais
              ou financeiros.</p>
              <p className="text_policy">Atenção: alguns desses serviços podem ser solicitados somente pelo usuário titular.
              Seus direitos</p>
              <p className="text_policy">A Lei Geral de Proteção de Dados (LGPD) dá ao cliente o direito de solicitar a Dental Center, em qualquer
              período, informações referentes aos dados tratados, mediante requisição formal (via email:
              atendimento@dentalcenterpb.com.br).</p>
              <p className="text_policy">Antes de prosseguirmos, é necessário esclarecer alguns conceitos:</p>
              <p className="text_policy">- Cliente: Toda pessoa física ou jurídica que utilizar nossos planos odontológicos.</p>
              <p className="text_policy">- Dados pessoais: Qualquer informação relacionada a uma pessoa que a identifique, podendo também,
              diante da natureza do nosso negócio, identificar seus dependentes.</p>
              <p className="text_policy">- Tratamento de dados pessoais: Nossa empresa considera tratamento de dado pessoal as seguintes
              ações: coleta, armazenamento, utilização (para acessar serviços), comunicação (comercial) e exclusão do
              nosso sistema.</p>
              <p className="text_policy">- Titular dados: Qualquer pessoa física que tenha seus dados pessoais tratados pela Dental Center.</p>
              <p className="text_policy">- Finalidade: Tratamos os dados pessoais com a finalidade de cadastrar e identificar o usuário.</p>
              <p className="text_policy">- Necessidade: Os dados coletados são utilizados para cadastro e identificação do usuário.</p>
              <p className="text_policy">- Consentimento: Quando o usuário dá permissão para que uma empresa ou serviço acesse seus dados
              para os fins propostos por elas.</p>
            </div>
            {/******** titulo 2 ********/}
            <div className="div_text_policy">
              <p className="title_policy">2. Como utilizamos seus dados pessoas:</p>
              <p className="text_policy">Sempre e quando o usuário necessitar acessar algum serviço referente a seu plano, através de:</p>
              <p className="text_policy">- SAC (Serviço de atendimento ao Cliente) via ligação, chat ou conversa no whatsapp;</p>
              <p className="text_policy">- Site planodentalcenter@.com, aplicativo DentalCenter Associado, diálogos na Aidê (Atendente Inteligente da Dental Center);</p>
              <p className="text_policy">Cookies/tecnologias similares, arquivo de logs e web Beacons</p>
              <p className="text_policy">Essas ferramentas proporcionam uma utilização personalizada dos serviços, através de meios digitais, já que armazenam informação fornecidas pelos próprios usuários durante um acesso.</p>
              <p className="text_policy">No entanto, afirmamos que nossa empresa NÃO utiliza nenhuma dessas ferramentas, justamente por representar um possível risco a segurança de dados.</p>
            </div>
            {/******** titulo 3 ********/}
            <div className="div_text_policy">
              <p className="title_policy">3. Com quem compartilhamos os dados dos clientes</p>
              <p className="text_policy">Asseguramos que os dados dos nossos usuários (titulares e dependentes) NÃO são compartilhados, repassados, fornecidos e/ou negociados com nenhum outro órgão, empresa ou instituição, de natureza particular ou pública.</p>
            </div>
            {/******** titulo 4 ********/}
            <div className="div_text_policy">
              <p className="title_policy">4. Como mantemos os dados dos usuários seguros</p>
              <p className="text_policy">- Seus dados pessoais são acessados apenas por colaboradores autorizados;</p>
              <p className="text_policy">- Utilizamos sistema próprio de armazenamento de dados que usa medidas de segurança razoáveis para evitar o acesso indevido ou não autorizado;</p>
              <p className="text_policy">- Contamos com você para a manutenção dos dados em segurança. Quando realizar seu acesso ao app ou portal do site, escolha uma senha difícil para que outras pessoas não consigam adivinhar. Você é responsável por manter esta senha confidencial por qualquer uso de sua conta.</p>
            </div>
            {/******** titulo 5 ********/}
            <div className="div_text_policy">
              <p className="title_policy">5. Alteração da nossa política de privacidade</p>
              <p className="text_policy">Este documento será alterado quando e sempre houver mudanças no armazenamento e tratamento de dados, recomendação e legislação em vigor.</p>
              <p className="text_policy">Esse processo poderá ocorrer a qualquer tempo, por isso é importante acessar frequentemente para verificar quaisquer atualizações.</p>
            </div>
            {/******** titulo 6 ********/}
            <div className="div_text_policy">
              <p className="title_policy">6. Contatos da Dental Center</p>
              <p className="text_policy">Se restou alguma dúvida ou deseje acessar serviços, você pode nos contactar através dos seguintes canais:
              </p>
              <p className="text_policy2">
                <span className="text_policy2_color">• SAC</span><br/>(83) 3041.4646              
                </p>
              <p className="text_policy2">
                <span className="text_policy2_color">• E-mail</span><br/>
                atendimento@dentalcenterpb.com.br
              </p>
              <p className="text_policy2">
                <span className="text_policy2_color">• Whatsapp</span><br/>
                (11) 4004-8790 (Aidê)
              </p>
            </div>
          </div>

           <hr className="hr_policy2" />
        </Container>

        {/* Retirar a seção de contatos da página 
        <Contact />
        */}
        <Footer />
      </div>

    );
  }
}
export default PrivacyPolicy;



/** WEBPACK FOOTER **
 ** ./src/components/PrivacyPolicy/PrivacyPolicy.js
 **/